// import summary from '../sample/invoices.json'
import moment from "moment";
import { GetCurrencySymbol } from "../../../../core/utils/GetCurrenciesData";

export const convert = (summary: any, translate: Function) => {
  let table: any;
  if (summary.length > 0) {
    table = summary
      .map((entry: any) => {
        const invoice_date = moment(entry.InvoiceDate);
        let event = {
            eventLabel: invoice_date.format("DD/MM/YYYY"),
          },
          fields = [
            {
              fieldName: "AffiliateNumber",
              fieldLabel: "Affiliate Number",
              fieldValue: entry.AfflNo,
              fieldType: "string",
            },
            {
              fieldName: "NUMBER",
              fieldLabel: translate("invoices.section.column.invoice.number"),
              fieldValue: entry.InvoiceNo,
              fieldType: "string",
            },
            {
              fieldName: "DATE",
              fieldLabel: translate("invoices.section.column.date"),
              fieldValue: invoice_date.format("DD/MM/YYYY"),
              fieldType: "string",
            },
            {
              fieldName: "AMOUNT",
              fieldLabel: translate("invoices.section.column.amount"),
              fieldValue: entry.PaidAmount,
              fieldType: "currency",
              ...(entry.PaidAmountCurrency !== "" && {
                customAttributes: {
                  currency: GetCurrencySymbol(entry.PaidAmountCurrency),
                },
              }),
            },
            {
              fieldName: "Download",
              fieldLabel: "",
              fieldValue: "Download",
              fieldURL: entry.InvoicePath,
              fieldPDFName: entry.InvoiceNo,
              fieldType: "url",
            },
          ];

        const obj = {
          event,
          fields,
        };

        obj.event = event;
        obj.fields = fields;

        return obj;
      })
      .filter((event: any) => !!event);
  }

  return {
    table,
  };
};
